(function($) {
	'use strict';

	var SELECTORS = {
		button:  '[data-warranty-button]',
		options: '[data-warranty-options]',
		cancel:  '[data-warranty-cancel]'
	};

	var ATTRIBUTES = {
		buttonTarget: 'target',
		requestURL:   'warrantyRequest'
	};

	var COLLAPSE_METHODS = {
		show: 'show',
		hide: 'hide'
	};

	var $buttons = $(SELECTORS.button);

	function setupDeviceForm(i, button) {
		var $options;
		var REQUEST_URL;

		var hasOptionsSet = false;
		var isLoading     = false;

		var $button      = $(button);
		var $form        = $('#warranty' + $button.data(ATTRIBUTES.buttonTarget));
		var $serverError = $('#servererror' + $button.data(ATTRIBUTES.buttonTarget));
		var $dataError   = $('#dataerror' + $button.data(ATTRIBUTES.buttonTarget));
		var $cancel      = $form.find(SELECTORS.cancel);

		if($form.length) {
			setupBootstrapCollapseable();
			getOptionsReference();
			getRequestUrl();

			$button.on('click', handleButtonClick);
			$cancel.on('click', hide);
		}

		function isCollapsed() {
			return !$form.hasClass('in');
		}

		function setupBootstrapCollapseable() {
			var collapseOptions = {
				toggle: false
			};

			$form.collapse(collapseOptions);
			$serverError.collapse(collapseOptions);
			$dataError.collapse(collapseOptions);
		}

		function getRequestUrl() {
			REQUEST_URL = $form.data(ATTRIBUTES.requestURL);
		}

		function getOptionsReference() {
			$options = $form.find(SELECTORS.options);
		}

		function addOption(index, value) {
			$options.append($('<option/>', {
				value: value.PackType,
				text : value.PackType
			}));
		}

		function show() {
			$form.collapse(COLLAPSE_METHODS.show);
		}

		function hide() {
			$form.collapse(COLLAPSE_METHODS.hide);
		}

		function displayDataError() {
			$dataError.collapse(COLLAPSE_METHODS.show);
		}

		function handleAjaxSuccess(responseData) {
			hideLoadingIndicator();
			isLoading = false;

			if(typeof responseData === 'object' && responseData.length > 0) {
				$.each(responseData, addOption);
				show();
				hasOptionsSet = true;
			} else {
				displayDataError();
			}
		}

		function displayAjaxError() {
			hideLoadingIndicator();
			isLoading = false;

			// Show error message
			$serverError.collapse(COLLAPSE_METHODS.show);
		}

		function showLoadingIndicator() {
			$button.attr('data-loading', '1');
		}

		function hideLoadingIndicator() {
			$button.attr('data-loading', null);
		}

		function handleOptionsRequest() {
			isLoading = true;
			showLoadingIndicator();
			// Submit ajax request
			$.get(REQUEST_URL)
				.done(handleAjaxSuccess)
				.fail(displayAjaxError);
		}

		function handleButtonClick(e) {
			e.preventDefault();
			e.stopImmediatePropagation();

			$serverError.collapse(COLLAPSE_METHODS.hide);
			$dataError.collapse(COLLAPSE_METHODS.hide);

			if(!isLoading && isCollapsed()) {
				if(hasOptionsSet) {
					show();
				} else {
					handleOptionsRequest();
				}
			} else {
				hide();
			}
		}
	}

	if($buttons.length) {
		$buttons.each(setupDeviceForm);
	}
})($jq);
